var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "grid-x grid-padding-x" }, [
      _c(
        "div",
        {
          staticClass: "cell auto crop-container",
          style: { backgroundImage: "url(" + this.image + ")" }
        },
        [
          _c("slim-cropper", { attrs: { options: _vm.slimOptions } }, [
            _c("input", { attrs: { type: "file" } })
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: _vm.fieldname },
            domProps: { value: _vm.uploadedFile }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cf57a3a", { render: render, staticRenderFns: staticRenderFns })
  }
}